import { fetchPostJson } from "@/api/generic_fetch"

declare global {
  interface Window {
    visit: object
  }
}

const trackVisit = async (url: string): Promise<void> => {
  const { visit } = window

  if (visit) {
    try {
      await fetchPostJson(url, { visit })
    } catch (_) {
      // Ignore POST failure
    }
  }
}

export { trackVisit }
